import { render, staticRenderFns } from "./Tools01.vue?vue&type=template&id=3ff5bef8&scoped=true"
import script from "./Tools01.vue?vue&type=script&lang=js"
export * from "./Tools01.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff5bef8",
  null
  
)

export default component.exports